import React from "react"
import styled from "styled-components"
import PhoneIcon from "../Icons/PhoneIcon"
import DefaultButton from "../button/DefaultButton"

const CallStickyFooter = styled.div`
  position: fixed;
  z-index: 10;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #fff;
  padding: 0;
  box-shadow: 0px 0 15px 0px rgba(0, 0, 0, 0.5);
  @media (min-width: 768px) {
    display: none;
  }
  > a,
  .btn {
    display: flex;
    border-radius: 0;
    width: 100%;
    .icon{
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .text{
      line-height: 30px;
    }
  }
  .btn {
    padding: 10px 15px;
    justify-content: center;
    background-color: #00A21E;
    border-color: #00A21E;
    color:#fff;
    & svg {
      fill: #fff !important;
      path {
        fill: #fff !important;
      }
    }
    &:before {     
      background: #030504;
    }
    &:hover{
      border-color:#030504;	
      color:#fff;		
      & svg {
        fill: #fff !important;
        path {
          fill: #fff !important;
        }
      }
    }
    .icon > svg {
      width: 20px;
    }
  }
`;
const CallSticky = () => {
	return(						
        <CallStickyFooter>
            <a href="tel:8776005980" aria-label="8776005980">
              <DefaultButton animation="true" icon={<PhoneIcon />} text="Call Us Now" /></a>
        </CallStickyFooter>
	)
}


export default CallSticky